<template>
  <div class="docker-server">
    <iframe name="iframeChild" id="iframeChild" v-bind:src="getPageUrl"
            frameborder="0" scrolling="auto" ref="iframeDom"
    >
    </iframe>
  </div>
</template>

<script>
  import request from "../../api/nesting";

  export default {
    name: "statement",
    data() {
      return {
        getPageUrl: ''
      }
    },
    created() {
      let configUrlType = ''
      switch (this.$route.path) {
        // 基地库存管理
        case '/baseStock':
          configUrlType = '45'
          break
        // 物流基地配送情况
        case '/statementDelivery':
          configUrlType = '46'
          break
        // 陆运调进明细
        case '/statementTransfer':
          configUrlType = '47'
          break
        // 水运调进明细
        case '/statementTransferDetails':
          configUrlType = '48'
          break
        // 基地月度配送明细
        case '/statementDeliveryDetails':
          configUrlType = '49'
          break
        // 基地年度调进明细
        case '/statementYearTransferDetails':
          configUrlType = '50'
          break
        // 基地年度配送明细
        case '/statementYearDeliveryDetails':
          configUrlType = '51'
          break
      }
      request.getCoalSupplySynergyUrl({
        configUrlType
      }).then(res => {
        if (res.status) {
          this.getPageUrl = `${res.data.configUrl}`
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  /** iframe样式 */
  #iframeChild {
    width: 100%;
    height: calc(100vh - 125px);
  }
</style>